import { Tag, TagsAPI } from '@brg/api';
import { useAPIMethodArray } from '../useAPIMethodArray';

export interface GetListArgs {
    entityTypes?: string[];
    context?: string[];
    groupIds?: string[];
    types?: number[];
    status?: number[];
    levels?: number[];
    symbols?: string[];
    search?: string;
    tagRefListId?: string[];
    isHeaderIgnored?: boolean;
    includeCount?: boolean;
    limit?: number;
    page?: number;
    filter?: number;
}

export const useGetAllTags = (request: GetListArgs | null, lang = 'en', t?: number, disabled?: boolean, shouldCacheValues?: boolean) =>
    useAPIMethodArray<Tag, any>(TagsAPI.GetTagsList, request, lang, t, disabled, shouldCacheValues);
import { Tag, TagsAPI } from '@brg/api';
import { useAPIMethodArray } from '../useAPIMethodArray';

export interface GetListArgs {
    entityTypes?: string[];
    context?: string[];
    groupIds?: string[];
    types?: number[];
    status?: number[];
    levels?: number[];
    symbols?: string[];
    search?: string;
    tagRefListId?: string[];
    isHeaderIgnored?: boolean;
    includeCount?: boolean;
    limit?: number;
    page?: number;
    filter?: number;
}

export const useGetAllTags = (request: GetListArgs | null, lang = 'en', t?: number, disabled?: boolean, shouldCacheValues?: boolean) =>
    useAPIMethodArray<Tag, any>(TagsAPI.GetTagsList, request, lang, t, disabled, shouldCacheValues);
